import React, { useEffect } from "react";
import { DatePicker, DatePickerInput, Button, Stack, Select, SelectItem, Tabs, Tab, TabList, TabPanels, TabPanel } from "@carbon/react";
import { CardComponent } from '../../../components/Layouts/Card.styles'
import Card from '../../../components/Layouts/Card';
import { Calendar } from "@carbon/icons-react";
import Typography from "../../../components/Basics/Typography";
import { g90, g100 } from '@carbon/themes';
import { useDispatch, useSelector } from 'react-redux'
import { useDatePicker, useSelect } from "../../../components/Inputs/Inputs.hooks";
import { checkErrorRequired } from "../../../modules/errors/validations";
import LoadingContent from "../../../components/Animations/LoadingContent";
import { InputWrapper } from "./CyclesWalls.styles";
import { onGetCycleWallReportThunk } from "./CyclesWalls.actions";
import CycleWallTable from "./CyclesWallsTable.Container";

const CyclesWallsContainer = () => {
  const dispatch = useDispatch()
  const today = new Date()
  const yesterday = new Date(today)
  yesterday.setDate(today.getDate() - 1)
  const { error, loading, data } = useSelector(state => state.cycleWall)

  const { error: dateError, value: dateValue, onChange: handleDateChange } = useDatePicker({
    initialValue: [yesterday],
    errorCallbacks: [checkErrorRequired()]
  })

  const dispatchCycleWalls = (date) => {
    handleDateChange(date)
    const currDate = date[0]
    const year = currDate.getFullYear();  // Get the year
    const month = currDate.getMonth() + 1;  // Get the month (0-indexed, so add 1)
    const day = currDate.getDate();  // Get the day of the month
    dispatch(onGetCycleWallReportThunk({ year, month, day }))
  }

  return (
    <>
      <Stack gap={3}>
        <CardComponent width="100%">
          <Card justifyContent='flex-start'>
            <Calendar size={18} />
            <Typography className='cds--type-heading-compact-01'>
              OTROS CICLOS
            </Typography>
          </Card>
          {loading && !error && (
            <LoadingContent />
          )}
          {!loading && error && (
            <>
              <InputWrapper>
                <DatePicker datePickerType="single" maxDate={yesterday.toISOString()} value={dateValue} dateFormat='d-m-Y' onChange={dispatchCycleWalls}>
                  <DatePickerInput placeholder="dd/mm/yyyy" labelText="Fecha del reporte" id="daily-datepicker" size="md" />
                </DatePicker>
                <CardComponent width="10%">
                  <Typography className='cds--type-heading-compact-01'>
                    No hay datos para este dia
                  </Typography>
                </CardComponent>
              </InputWrapper>
            </>
          )}
          {!loading && !error && (
            <Card>
              <Card background={g100.background} width='100%' flexDirection='column' alignItems='left' gap='20px'>
                <InputWrapper>
                  <DatePicker
                    datePickerType="single"
                    maxDate={yesterday.toISOString()}
                    value={dateValue}
                    dateFormat="d-m-Y"
                    onChange={dispatchCycleWalls}
                  >
                    <DatePickerInput
                      placeholder="dd/mm/yyyy"
                      labelText="Fecha del reporte"
                      id="daily-datepicker"
                      size="md"
                      style={{ width: '15vw' }}
                    />
                  </DatePicker>
                </InputWrapper>
                <CycleWallTable />
              </Card>
            </Card>
          )}
        </CardComponent>
      </Stack>
    </>
  )
};

export default CyclesWallsContainer;